import { useEffect } from 'react';

export function useUnmount(unmountCallback: () => void) {
  useEffect(() => {
    return unmountCallback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
